export default "__VITE_ASSET__jvvIFqSb__"